import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ViewController, NavParams, AlertController } from 'ionic-angular';

import { Assignment, User  } from '@providers/asset/index';

import { DetailItemPage, SelectPage, ItemPage } from '../';

@Component({
  selector: 'page-ls-assignment',
  templateUrl: 'page.html'
})
export class LsAssignmentPage {

  item = {
    assignee_id:''
  }

  List: any;
  selectedID= [0];
  user_data: any = [];
  count_assignment = 0;

  constructor(
    public navCtrl: NavController,
    public assignmentApi: Assignment,
    public userApi : User,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public alertCtrl : AlertController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {

    this.user_data = JSON.parse(localStorage.data_user);
    this.item.assignee_id=this.user_data.data.employee_id;

  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { assignee_id:this.item.assignee_id };
    this.assignmentApi.get(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.List = resp.data;
        this.count_assignment = resp.count;
      } 
      if(resp.count==0){
        this.presentToast("Anda belum mendapatkan penugasan");
      }
      console.log("data list Assignment => ",resp);
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });

  }

  select(akses_sts, asset_id, id, location_id, loc_path, project_code, project_title, asset_classification_code){
    let params : any = {
      assignment_id:id,
      assign:1, 
      selectMod:1};
      if(location_id!=null){
        params.asset_location_id=location_id, 
        params.location_path_id=loc_path,
        params.assign_type = 'location';
      }
      if(project_code!=''){
        params.project_code=project_code,
        params.project_title = project_title,
        params.assign_type  = 'project';
      }
      if(asset_id!=0){
        params.id=asset_id
      }
      if(asset_classification_code!=''){
        params.classification_code = asset_classification_code
      }
    if(akses_sts==1){
      if(asset_id==0){
        this.navCtrl.push(ItemPage, params)
      }else{
        this.navCtrl.push(DetailItemPage, params);
      }
    }else{
      this.presentToast("Hak akses untuk penugasan ini sudah dicabut !");
    }

    console.log("params assign =>",params);
  }

  finish_assign(id){
    const confirm = this.alertCtrl.create({
      title: 'Finish Assignment',
      message: 'Anda yakin telah selesai mengerjakan penugasan ini dan ingin mengirim pemberitahuan kepada penugas ?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Ya',
          handler: () => {
            let params:any={
              id:id,
              status :1
            }
            this.assignmentApi.save(params).subscribe((resp:any) => {
              this.getList();
            });
          }
        }
      ]
    });
    confirm.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/ls_assignment/page.ts